import React, { useState } from 'react'
import AgriPromoterTargetForm from './AgriPromoterTargetForm';
import AgriPromoterTargetList from './AgriPromoterTargetList';

const AgriPromoterTarget = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AgriPromoterTargetForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AgriPromoterTargetList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default AgriPromoterTarget